import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axiosTokenInstance from "../../services/axiosInstance";
import { jwtDecode } from "jwt-decode";
import { showToast } from "../../utils/helpers";

const LogoutHandler = () => {
  const { logout, getAccessTokenSilently, isAuthenticated } = useAuth0();
  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  // Function to check if the token is expired
  const checkTokenExpiration = async () => {
    try {
      const token = await getAccessTokenSilently();
      if (!token) handleLogout();

      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      // Check if the token is expired
      if (decodedToken.exp < currentTime) {
        showToast("Token expired. Logging out...", "error");
        handleLogout();
      }
    } catch (error) {
      console.error("Error decoding token or checking expiration:", error);
    }
  };

  useEffect(() => {
    // Function to handle logout on axios 401 errors
    const checkForLogoutOn401 = () => {
      axiosTokenInstance.interceptors.response.use(
        (response) => response,
        (error) => {
          if (
            (error.response && error.response.status === 401) ||
            (error.response && error.response.status === 403)
          ) {
            handleLogout();
          }
          return Promise.reject(error);
        }
      );
    };

    // Start the session expiration check interval
    const sessionCheckInterval = setInterval(
      checkTokenExpiration,
      1000 * 60 * 10
    ); // Check every 10 minutes

    checkForLogoutOn401();

    // Cleanup the interval and interceptors when the component unmounts
    return () => {
      clearInterval(sessionCheckInterval);
      axiosTokenInstance.interceptors.response.handlers = [];
    };
  }, [logout, getAccessTokenSilently]);

  return null;
};

export default LogoutHandler;
